export default [
    'BAU',
    'Project'
]
export const activityTypeEnums = Object.freeze(({ 'BAU': 0, 'Project': 1 }));
